import axiosInstance from "../axiosInstance";

interface RisingStarResponse {
  risingStarLevel: number | null;
}
export async function getAgentRisingStarLevel(agentNumber: string): Promise<RisingStarResponse> {
  const response = await axiosInstance.get(`/admin/agents/${agentNumber}/rising-star`);

  return {
    risingStarLevel: response.data?.message ?? null,
  };
}


